const { formatText } = require('core/i18n').i18n;


const stocksSectorHelper = id => (
    {
        101: formatText('stocksSector-basicMaterials'), // Basic Materials
        308: formatText('stocksSector-communicationServices'), // Communication Services
        102: formatText('stocksSector-consumerCyclical'), //  Consumer Cyclical
        205: formatText('stocksSector-consumerDefensive'), //  Consumer Defensive
        206: formatText('stocksSector-healthcare'), //  Healthcare
        310: formatText('stocksSector-industrials'), //  Industrials
        104: formatText('stocksSector-realEstate'), //  Real Estate
        311: formatText('stocksSector-technology'), //  Technology
        309: formatText('stocksSector-energy'), //  Energy
        103: formatText('stocksSector-financialServices'), //  Financial Services
        207: formatText('stocksSector-utilities'), //  Utilities
    }[id]
);


module.exports = stocksSectorHelper;
